import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { Helpers } from "../helpers/helpers";
import { environment } from "../environments/environment";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AgentService extends BaseService {
  constructor(private http: HttpClient, helper: Helpers) {
    super(helper);
  }

  private pathAPI = environment.apiUrl;

  createAgent(data: any): Observable<any> {
    return this.http
      .post<any>(this.pathAPI + "Agents", data, super.header())
      .pipe(catchError(super.handleError));
  }
  getAgentList(): any {
    return this.http
      .get<any>(this.pathAPI + "Agents", super.header())
      .pipe(catchError(super.handleError));
  }
  getAgentById(id: any): any {
    return this.http
      .get<any>(this.pathAPI + "Agents/" + id, super.header())
      .pipe(catchError(super.handleError));
  }

  deleteAgent(id: string): any {
    return this.http
      .delete<any>(this.pathAPI + "Agents/" + id, super.header())
      .pipe(catchError(super.handleError));
  }

  resetPasswordAgent(id: any): any {
    return this.http
      .patch<any>(
        this.pathAPI + "Agents/" + id + "/ResetPassword",
        {},
        super.header()
      )
      .pipe(catchError(super.handleError));
  }

  updateAgent(id: any, data: any): any {
    return this.http
      .put<any>(this.pathAPI + "Agents/" + id, data, super.header())
      .pipe(catchError(super.handleError));
  }
}
